import { InventoryTransferIndexPage } from "./InventoryTransferIndexPage";
export default InventoryTransferIndexPage;
